import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

import { TrackingEvents, TrackingPayload } from '../core.types';

type TrackAuctionHouseSuggestionClickPayload = TrackingPayload & {
    houseId: number;
};

export const trackAuctionHouseSuggestionClickAnalytics = (payload: TrackAuctionHouseSuggestionClickPayload) => {
    track(TrackingEvents.SearchPage.AuctionHouseSuggestionClicked, payload);
};

export const useTrackAuctionHouseSuggestionClick = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ houseId }: Omit<TrackAuctionHouseSuggestionClickPayload, 'pageName' | 'url'>) => {
            return trackAuctionHouseSuggestionClickAnalytics({
                houseId,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
